import { useState, useEffect, useCallback } from 'react';
import {
  subscribe,
  getWakeUpState,
  checkServerHealth,
} from '../services/api/serverWakeUp';
import type { WakeUpStatus } from '../services/api/serverWakeUp';

interface UseServerWakeUpReturn {
  status: WakeUpStatus;
  message: string;
  isWaking: boolean;
  isReady: boolean;
  isError: boolean;
  retry: () => void;
}

/**
 * 서버 wake-up 상태를 추적하는 Hook
 * @param autoCheck - 마운트 시 자동으로 health check 실행 (기본: true)
 */
export function useServerWakeUp(
  autoCheck: boolean = true
): UseServerWakeUpReturn {
  const [state, setState] = useState(getWakeUpState());

  useEffect(() => {
    return subscribe(setState);
  }, []);

  useEffect(() => {
    if (autoCheck) {
      checkServerHealth();
    }
  }, [autoCheck]);

  const retry = useCallback(() => {
    checkServerHealth();
  }, []);

  return {
    status: state.status,
    message: state.message,
    isWaking: state.status === 'checking' || state.status === 'waking',
    isReady: state.status === 'ready' || state.status === 'idle',
    isError: state.status === 'error',
    retry,
  };
}
